export enum SortDirectionEnum {
    Asc = 1,
    Desc = 2
}
